import { styled } from '@mui/system';
export const HeaderBar = styled("div")(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 20,
  marginBottom: 10,
  padding: "8px 12px",
  backgroundColor: theme.palette.primary.main,
  alignItems: 'center'
}));